import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Alert,
} from "@mui/material";
import { useTranslation } from "react-i18next";

export function NavigationBlockerDialog({
  open,
  onConfirm,
  onCancel,
}: {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  const { t } = useTranslation("scenes.TaxResolutions.index");

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogContent sx={{ pt: 3 }}>
        <Alert severity="warning" variant="outlined">
          {t("unsaved_changes")}
        </Alert>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onCancel} color="inherit">
          {t("stay")}
        </Button>
        <Button onClick={onConfirm} color="warning" variant="contained">
          {t("leave_page")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}